<template>
  <LLOptionsList
    class="notifications-item-actions"
    :disabled="isPending"
    :offset="[0, 0]"
    placement="bottom-end"
  >
    <template #trigger>
      <LLButton tiny tertiary-dark>
        <template #icon-left>
          <OptionsIcon v-if="!isPending" />
          <LLLoader v-else class="notifications-item-actions__loader"></LLLoader>
        </template>
      </LLButton>
    </template>
    <template #buttons>
      <LLOptionsListButton v-if="!isRead" small @click="setReadState(true)">
        {{ $t('notifications.item.actions.mark_as_read') }}
      </LLOptionsListButton>
      <LLOptionsListButton v-if="isRead" small @click="setReadState(false)">
        {{ $t('notifications.item.actions.mark_as_unread') }}
      </LLOptionsListButton>
      <LLOptionsListButton small @click="clear">
        {{ $t('notifications.item.actions.clear') }}
      </LLOptionsListButton>
    </template>
  </LLOptionsList>
</template>

<script>
import LLOptionsListButton from '@/components/common/LLOptionsList/LLOptionsListButton.vue'
import LLButton from '@/components/common/ui-components/LLButton.vue'
import LLOptionsList from '@/components/common/LLOptionsList.vue'
import OptionsIcon from '@/assets/icons/OptionsIcon.vue'
import { NotificationModel } from '@/models/notification'
import LLLoader from '@/components/common/LLLoader.vue'

export default {
  name: 'NotificationsItemActions',
  components: { LLLoader, OptionsIcon, LLOptionsList, LLButton, LLOptionsListButton },
  props: {
    notification: { type: NotificationModel, required: true }
  },
  data() {
    return {
      isPending: false
    }
  },
  computed: {
    isRead() {
      return this.notification.isRead
    }
  },
  methods: {
    async setReadState(state) {
      try {
        this.isPending = true
        await this.$api.notifications.setReadState({ id: this.notification.id, isRead: state })
        const newNotification = new NotificationModel({
          ...this.notification,
          isRead: state
        })
        this.$emit('update', { notification: newNotification })
        this.isPending = false
      } catch (e) {
        console.error(e)
      }
    },
    async clear() {
      try {
        this.isPending = true
        await this.$api.notifications.clear({ id: this.notification.id })
        const newNotification = new NotificationModel({
          ...this.notification,
          isCleared: true
        })
        this.$emit('update', { notification: newNotification })
        this.isPending = false
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.notifications-item-actions {
  &__loader {
    @apply w-4 h-4;
  }
}
</style>
